import { LinkButton, type LinkButtonProps, LinkType } from "~/common/components/Link";
import { type ReactNode } from "react";
import { forwardRef } from "react";
import { styled } from "~/common/mui";

interface Props extends Omit<LinkButtonProps, "children"> {
  icon: ReactNode;
  outlinedIcon?: boolean;
  active?: boolean;
}

export const MobileNavButton = forwardRef<HTMLButtonElement, Props>(({ active, icon, ...rest }, ref) => {
  return (
    <StyledLinkButton variant={active ? LinkType.PRIMARY : LinkType.NAVIGATION} ref={ref} {...rest}>
      {icon}
    </StyledLinkButton>
  );
});

const StyledLinkButton = styled(LinkButton)(({ theme }) => ({
  flex: "none",
  [theme.breakpoints.down("desktop-s")]: {
    height: 40,
    width: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  "&.scha__link--navigation": {
    color: theme.palette.text.secondary,
  },
  "&.scha__mobile-navigation__button--outlined-icon svg": {
    outline: `1px solid ${theme.palette.divider}`,
    outlineOffset: theme.spacing(1),
    borderRadius: "50%",
  },
}));
